import { Injectable } from '@angular/core';
import { UserRoles } from 'src/app/models/enums/user-roles';
import { ActionPerform, AssignedTo, FileParameter, HangfireJobClient, NotificationStatus, PayToEnum } from 'src/app/web-api-client';
import { UserService } from '../user.service';
import { DatePipe } from '@angular/common';
import { CommentService } from '../comment.service';
import { DocumentService } from '../document.service';
import { AddCommentDto } from 'src/app/models/AddCommentDto';
import { CommentType } from 'src/app/models/enums/CommentType';
import { NotificationFrequency } from 'src/app/models/enums/NotificaionFrequency';
import { NotificationType } from 'src/app/models/enums/NotificationType';
import { UserAction } from 'src/app/models/enums/user-actions';
import { UserActivityService } from '../userActivity.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  // constructor
  constructor(private userService: UserService, private datePipe: DatePipe, private hangfireJobExecutionService: HangfireJobClient,
    private commentService: CommentService, private documentService: DocumentService, private userActivityService: UserActivityService
  ) { }

  // get task status text from number
  getTaskStatusByNumber(n: number, isApproval: boolean = false) {

    switch (n) {
      case 0:
        return "Open";
      case 1:
        if (!isApproval) {
          return "Closed";
        } else {
          return "Approved"
        }

      case 4:
        return "Deleted"
      case 5:
        return "Hidden"
      case 6:
        return "Finalized"
      case 7:
        return "In-progress"
      case null:
        return "All status"
      default:
        return "Open";
    }
  }

  getPayToText(value: PayToEnum) {
    switch (value) {
      case null:
        return "All payments"
      case 1:
        return 'Insurope';
      case 2:
        return 'Client';
      case 3:
        return 'Other';
      default:
        return '';
    }
  }

  async displayTaskAction(task: any): Promise<boolean> {
    let currentUser = await this.userService.getCurrentUser();
    let displayActions = true;
    switch (task.assignedTo) {
      case AssignedTo.NetworkMember:
        if (!(await this.userService.isUserInRole(UserRoles.NetworkMember) && currentUser.networkMemberIds.includes(task.networkMemberId)))
          displayActions = false;
        break;
      case AssignedTo.Internal:
        if (!await this.userService.isUserInRole(UserRoles.Collaborator))
          displayActions = false;
        break;
      case AssignedTo.Client:
        if (!(await this.userService.isUserInRole(UserRoles.Client) && currentUser.clientId == task.clientId))
          displayActions = false;
        break;
    }
    return displayActions;
  }

  getLastModifiedDate(items: any) {

    var lastModifiedDate = items.reduce((item, curr) => {
      return item.lastModified < curr.lastModified ? curr : item;
    }).lastModified;

    return "Last refresh : " + this.datePipe.transform(lastModifiedDate, "medium");
  }

  async getHangfireJobStartDateExecution(processName) {
    var lastModifiedDate = (await this.hangfireJobExecutionService.getJobInfo(processName).toPromise()).endDate;
    return "Last refresh : " + this.datePipe.transform(lastModifiedDate, "medium")
  }

  async treatedByNetworkMember(task: any, service: any): Promise<boolean> {
    const isNetworkMember = await this.userService.isUserInRole(UserRoles.NetworkMember);
    const isCollaborator = await this.userService.isUserInRole(UserRoles.Collaborator);

    if ((task.actionPerform == ActionPerform.MarkAsNotDone || task.actionPerform == null) && isNetworkMember) {
      if (await service.changeActionPerform(task.id, ActionPerform.MarkAsDone)) {

        task.actionPerform = ActionPerform.MarkAsDone;
        task.actionPerformedDate = new Date();  

        let fileList: FileParameter[] = [];

        for (let i = 0; i < task.adminDbAttachments.length; i++) {
          const file = await this.documentService.getAdminDbDocument(task.adminDbAttachments[i], [task.networkMemberId]);
          fileList.push({ data: new Blob([file.data]), fileName: file.fileName });
        }

        const commentDto: AddCommentDto = {
          taskId: task.id,
          content: "<p><b>This task was handled by a Network Member</b></p>",
          processName: task.processId || task.process,
          clientName: task.title,
          networkMemberName: task.networkMember.accountName,
          country: null,
          files: fileList,
          tags: null,
          isDeleted: false,
          isEdited: false,
          isHtmlText: true,
          commentType: CommentType.Comment,
          notificationFrequency: NotificationFrequency.Instantly,
          notificationType: NotificationType.EmailNotification,
          notificationStatus: NotificationStatus.New
        };

        var newComment = await this.commentService.addComment(commentDto);
        if (newComment) {
          this.commentService.filteredComments.sort((a, b) => 
            new Date(b.messageSent).getTime() - new Date(a.messageSent).getTime()
          );
        }
        
        return true;
      }
    } 
    else if (task.actionPerform == ActionPerform.MarkAsDone && isCollaborator) {
      task.actionPerform = ActionPerform.MarkAsNotDone;
      task.actionPerformedDate = new Date();  

      await service.changeActionPerform(task.id, ActionPerform.MarkAsNotDone);

      const commentDto: AddCommentDto = {
        taskId: task.id,
        content: "<p><b>The task was marked as not handled</b></p>",
        processName: task.processId || task.process,
        clientName: task.title,
        networkMemberName: task.networkMember.accountName,
        country: null,
        files: [],
        tags: null,
        isDeleted: false,
        isEdited: false,
        isHtmlText: true,
        commentType: CommentType.Comment,
        notificationFrequency: NotificationFrequency.Instantly,
        notificationType: NotificationType.EmailNotification,
        notificationStatus: NotificationStatus.New
      };
      
      var newComment = await this.commentService.addComment(commentDto);
      if (newComment) {
        this.commentService.filteredComments.sort((a, b) => 
          new Date(b.messageSent).getTime() - new Date(a.messageSent).getTime()
        );
      }

      return true;
    }

    return false;
  }

  async logUserAction(action: UserAction, taskId: string, processId: string, path: string = "") {  
    var user = await this.userService.getCurrentUser();
    if (path == "") {
      path = window.location.href;
    }
    return await this.userActivityService.logUserActivity(action, user.id, user.email, path, taskId, processId);
  }  
  
}
